<template>
  <div class="fixed top-0 z-10 w-full bg-white shadow">
    <div class="container mx-auto">
      <nav class="flex flex-wrap items-center content-center justify-center w-full p-4 sm:justify-between sm:p-5" role="navigation" aria-label="Main">
        <div class="flex items-center justify-center w-full text-black sm:mr-6 flex-no-shrink sm:w-auto">
          <a :href="baseDomain">
            <img src="../assets/images/logo.png" class="h-6 sm:h-10" alt="Post Office Logo"/>
          </a>
          <span class="ml-4 tracking-tight sm:text-2xl">Post Office</span>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data: () => {
      return {
        baseDomain: process.env.VUE_APP_POL_BASE_DOMAIN
      }
    }
  };
</script>
